__turbopack_context__.v({
  "className": "biz_udpgothic_36a70bb-module__SkHqzG__className",
});
